import React from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';

export default function Nav({ mobileOpen, setMobileOpen, theme, toggleTheme, logoSrc = '/siju-tech-logo.png' }) {
  return (
    <nav className="comp-nav">
      <div className="comp-logo">
        <img src={logoSrc} alt="Aurora Tech logo" className="comp-logo-img" />
        <span className="comp-brand">Aurora Tech</span>
      </div>

      <button
        className="menu-btn"
        aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
        onClick={() => setMobileOpen((v) => !v)}
      >
        {mobileOpen ? '✕' : '☰'}
      </button>

      <ul className={`comp-links ${mobileOpen ? 'open' : ''}`}>
        <li><a href="#services" onClick={() => setMobileOpen(false)}>Services</a></li>
        <li><a href="#work" onClick={() => setMobileOpen(false)}>Work</a></li>
        <li><a href="#team" onClick={() => setMobileOpen(false)}>Team</a></li>
        <li><a href="#contact" onClick={() => setMobileOpen(false)}>Contact</a></li>
        <li><Link to="/client/login" className="nav-btn-mobile" onClick={() => setMobileOpen(false)}>Client Login</Link></li>
      </ul>

      {/* <div className="comp-controls"> */}
        {/* Client login button (visible on desktop) */}
        {/* <Link to="/client/login" className="nav-btn" aria-label="Client login">Client Login</Link> */}
        {/* theme toggle moved to page root to ensure fixed positioning */}
      {/* </div> */}
    </nav>
  );
}
